export const PRODUCT_SEARCH_SERVER_BASICS_DETAILS = `
fragment ProductSearchBasicDetails on Product {
    id: uniqueId
    productId: id
    bulkAvailable
    hasTierPricing
    minOrderableQuantity
    name
    description
    baseImage: displayImage
    slug
    intent
    servingInfo
    blankProductId
    ecoFriendly
    sustainable
    shippedFromStadium
    coreOnDemand
    updatedAt
    usdPrices(storeUpcharge: $storeUpcharge)
    storeProduct {
      id
      catalogStoreId
      embroidery
    }
    colorsCount
    variants @include(if: $includeProductVariants) {
      id
      externalId
      prices: usdPrices(storeUpcharge: $storeUpcharge)
      isMaster
      minOrderableQuantity
      optionTypes {
        key
        optionId: id
        name
        presentation
        value
      }
      baseImage
    }
    brand: brandByCountry {
      id
      displayName: name
    }
    brands {
      countryCodes
      global
    }
    type
    broken
    brokenVariantId
    colorOptions {
      id
      presentation
      value
    }
    colorOptionsCount
  }
`;

export const PRODUCT_SEARCH_SERVER_BASICS_DETAILS_FOR_BRANDS = `
fragment ProductSearchBasicDetailsForBrands on Product {
    id: uniqueId
  }
`;
